import {Component, Input} from '@angular/core';
import {SSOProvider} from "../../_types/auth";
import {AuthService} from "../../_services/auth.service";
import {SnackbarService} from "../../_services/snackbar.service";


@Component({
    selector: 'app-sso-buttons',
    standalone: false,
    templateUrl: './sso-buttons.component.html',
    styleUrl: './sso-buttons.component.scss',
})
export class SsoButtonsComponent {
    @Input() providers: SSOProvider[] = []
    @Input() keepMeLoggedIn: boolean = false;
    @Input({required: true}) community!: number


    constructor(private authService: AuthService,
                private readonly snack: SnackbarService) {
    }

    /**
     * Every provider, Apple included, starts the same way: the backend builds the
     * authorize URL (owning redirect_uri, scope, PKCE/nonce and state) and we send
     * the browser there. The provider returns to
     * `<SSO_CALLBACK_BASE_URL>/auth/<provider>/cb`, handled by PassthroughComponent.
     *
     * Apple can't GET-redirect once name/email scopes are requested, so it
     * form-posts to an API-hosted bridge which 303s on to that same callback with
     * id_token/user/state as query params. From here that is invisible.
     */
    authRedirect(provider: SSOProvider): void {
        this.authService.SSOLoginRedirect(provider.provider, this.community, this.keepMeLoggedIn).subscribe({
            next: (res): void => {
                window.location.assign(res.data.url)
            },
            error: (e): void => {
                console.error(e)
                this.snack.openErrorSnackBar('Could not start sign-in: ' + e);
            }
        });
    }
}
